import { authAPI } from './api';

export interface TwoFactorStatus {
  enabled: boolean;
  required: boolean;
  has_secret?: boolean;
}

export interface TwoFactorSetupResponse {
  secret: string;
  qr_code_url: string;
  otpauth_url?: string;
  message?: string;
}

export interface TwoFactorVerifyResponse {
  message: string;
  backup_codes?: string[];
  warning?: string;
}

export interface Disable2FAResponse {
  message: string;
}

export const getTwoFactorStatus = async (): Promise<TwoFactorStatus> => {
  const { data } = await authAPI.get<TwoFactorStatus>('/auth/2fa/status');
  return data;
};

export const startTwoFactorSetup = async (): Promise<TwoFactorSetupResponse> => {
  const { data } = await authAPI.post<TwoFactorSetupResponse>('/auth/2fa/setup');
  return data;
};

export const verifyAndEnableTwoFactor = async (
  secret: string,
  code: string,
): Promise<TwoFactorVerifyResponse> => {
  const { data } = await authAPI.post<TwoFactorVerifyResponse>('/auth/2fa/verify', {
    secret,
    code,
  });
  return data;
};

export const disableTwoFactor = async (code: string): Promise<Disable2FAResponse> => {
  const { data } = await authAPI.post<Disable2FAResponse>('/auth/2fa/disable', { code });
  return data;
};

export interface TwoFactorVerifyCodeResponse {
  message: string;
  token: string;
  refresh_token: string;
  user: any;
}

export const verify2FACodeForLogin = async (
  userId: string,
  code: string,
): Promise<TwoFactorVerifyCodeResponse> => {
  const { data } = await authAPI.post<TwoFactorVerifyCodeResponse>('/auth/2fa/verify-code', {
    user_id: userId,
    code,
  });
  return data;
};

